export default __webpack_public_path__ + "static/media/Shop2.b1e4e8db.png";